import { legit } from 'apex-legit-service'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { Button, Form, InputOnChangeData, Loader } from 'semantic-ui-react'
import { ALL_REQUESTED_PERMISSIONS, LEGIT_SERVICE_CONFIG } from '../../constants'
import { RootState } from '../../store'
import { useFormatMessage } from '../../utils'
import { setRumUser } from '../../utils/datadog'
import { isPrimitiveEmpty } from './ApexLogin'
import styles from './styles.module.less'

const INVALID_CREDENTIALS = 'Incorrect Username/Password'

export interface ApexLegacyLoginProps {
  defaultUsername: string
  loggingIn: boolean
  legacyLoginSubmit: (params: { username: string; password: string }) => void
  loginFailed: boolean
}
export const ApexLegacyLoginComponent = ({
  defaultUsername,
  loggingIn,
  legacyLoginSubmit,
  loginFailed,
}: ApexLegacyLoginProps) => {
  const formatMessage = useFormatMessage()
  const [username, setUsername] = useState(defaultUsername)
  const [password, setPassword] = useState('')
  const [usernameError, setUsernameError] = useState<boolean>(false)
  const [passwordError, setPasswordError] = useState<boolean>(false)

  const handleLegacyLogin = (event: React.SyntheticEvent) => {
    setUsernameError(isPrimitiveEmpty(username))
    setPasswordError(isPrimitiveEmpty(password))

    if (!isPrimitiveEmpty(username) && !isPrimitiveEmpty(password)) {
      legacyLoginSubmit({ username: username, password: password })
      setRumUser({ loginType: 'legacy' })
    }
  }

  const onUsernameChange = (value: string) => {
    setUsernameError(isPrimitiveEmpty(value))
    setUsername(value)
  }

  const onPasswordChange = (value: string) => {
    setPasswordError(isPrimitiveEmpty(value))
    setPassword(value)
  }

  return loggingIn ? (
    <Loader active={loggingIn} />
  ) : (
    <>
      <Form className={styles.legacyLogin} onSubmit={handleLegacyLogin} error={true}>
        <Form.Input
          className={'test-id-legacy-username'}
          value={username}
          label={formatMessage('login.username')}
          onChange={(e: React.SyntheticEvent, data: InputOnChangeData) => onUsernameChange(data.value)}
          required={true}
          error={
            usernameError && {
              content: formatMessage('login.username.required'),
            }
          }
        />
        <Form.Input
          className={'test-id-legacy-password'}
          label={formatMessage('login.password')}
          value={password}
          onChange={(e: React.SyntheticEvent, data: InputOnChangeData) => onPasswordChange(data.value)}
          type="password"
          required={true}
          error={
            passwordError && {
              content: formatMessage('login.password.required'),
            }
          }
        />
        {loginFailed && (
          <div className={styles.loginError}>
            <label className="label error">{INVALID_CREDENTIALS}</label>
          </div>
        )}
        <Button type="submit" disabled={loggingIn} fluid={true}>
          {formatMessage('login.signin')}
        </Button>
      </Form>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  const {
    [legit.NAMESPACE]: { error, params },
  }: { [index: string]: any } = state
  const loginFailed = error?.message === 'Unauthorized' && params?.apexUser && !!params?.username
  return { loginFailed }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  legacyLoginSubmit: (params: { username: string; password: string }) => {
    dispatch(
      legit.login(LEGIT_SERVICE_CONFIG, {
        apexUser: true,
        ...params,
        permissions: ALL_REQUESTED_PERMISSIONS,
      })
    )
  },
})

export const ApexLegacyLogin = connect(mapStateToProps, mapDispatchToProps)(ApexLegacyLoginComponent)
